import React, { useState, useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { Formik } from 'formik';
import styled from 'styled-components';
import { helpSchema } from './schemas';
import DataState from '../DataState';
import AuthContext from '../../contexts/AuthContext';
import { useMutation, useLazyQuery } from '@apollo/client';
import { REQUEST_ASSISTANCE } from './queries';
import { formatAuthErrors } from '../../utils/errorHelpers';

import {
  Label,
  Button,
  CancelButton,
  Input,
  ErrorMessage,
  TextArea,
  Container,
  TitleContainer,
  Title,
  SubTitle,
  ButtonRow,
} from './elements';

export const Text = styled.div`
  color: #898989;
  font-weight: bold;
`;

const inputBackground = {
  backgroundColor: '#EFEFEF',
  border: 'none'
}

const Assistance = (props) => {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [sendSuccess, setSendSuccess] = useState(false);
  const [sendFailure, setSendFailure] = useState(false);
  const { user, refetchData } = useContext(AuthContext);

  const [requestAssistance] = useMutation(REQUEST_ASSISTANCE, {
    onCompleted: data => {
      setSendSuccess(true)
    },
    onError: error => {
      setErrorMessage(formatAuthErrors(error.graphQLErrors));
      setSendFailure(true)
      setFormSubmitting(false);
    }
  });

  const handleSubmit = (values) => {
    requestAssistance({ variables: values })
  }

  const showContent = () => {
    if(sendSuccess) {
      return (
        <>
          <SubTitle>
            Request Success
          </SubTitle>
          <Text>
            We have received your request, and you should expect to receive a call
            from Fly Louie momentarily.
          </Text>
        </>
      )
    }else if(sendFailure) {
      return (
        <>
          <SubTitle>
            Send Request Error
          </SubTitle>
          <Text>
            Your request has encountered an error. We have been notified of this
            issue and will work to resolve it.
            <br />
            Please contact us at:
            833-FLY-LOUIE (833-359-5684) or fuel@flylouie.com
          </Text>
        </>
      )
    }else {
      return (
        <>
          <Text>
            Use this form to request an immediate callback from Fly Louie.
          </Text>
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

          {formSubmitting || !user ? <DataState.Loading /> : (
            <Formik
              initialValues={{
                name: user?.fullName || '',
                email: user?.email || '',
                phone: user?.mobilePhone?.value || user?.officePhone?.value || '',
                tailNumber: '',
                issue: ''
              }}
              validationSchema={helpSchema}
              onSubmit={handleSubmit}
            >
              {props => (
                <form onSubmit={props.handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <Label>Your Name</Label>
                      <Input
                        type="text"
                        name="name"
                        style={inputBackground}
                      />
                      <Label>Email</Label>
                      <Input
                        type="email"
                        name="email"
                        style={inputBackground}
                      />
                    </div>
                    <div className="col-md-6">
                      <Label>Phone Number</Label>
                      <Input
                        type="phone"
                        name="phone"
                        style={inputBackground}
                      />
                      {/* <PhoneInput */}
                      {/*   type="phone" */}
                      {/*   name="phone" */}
                      {/*   style={phoneInputStyle} */}
                      {/*   // onChange={(event) => */}
                      {/*   //   StringHelpers.handleNumberChange(event, "phone", props.setFieldValue) */}
                      {/*   // } */}
                      {/*   value={props.values.phone} */}
                      {/* /> */}
                      <Label>Tail Number</Label>
                      <Input
                        type="text"
                        name="tailNumber"
                        style={inputBackground}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <Label>Briefly Describe Your Issue</Label>
                      <TextArea
                        name="issue"
                        type="text"
                        style={{
                          marginTop: '-20px',
                          backgroundColor: '#EFEFEF',
                          border: 'none'
                        }}
                      />
                    </div>
                  </div>
                  <ButtonRow className="row">
                    <div className="col-md-6">
                      <CancelButton
                        type="button"
                        onClick={() => props.resetForm()}
                      >
                        Cancel
                      </CancelButton>
                    </div>
                    <div className="col-md-6">
                      <Button type="submit">
                        Submit
                      </Button>
                    </div>
                  </ButtonRow>
                </form>
              )}
            </Formik>
          )}
        </>
      )
    }
  }

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Container>
        <TitleContainer>
          <Title>
            Request Assistance
          </Title>
        </TitleContainer>
        {showContent()}
      </Container>
    </>
  )
}

export default Assistance;